import { BaseManager, BaseListManager } from "./index.js";
import { CongressService } from "@/modules/api.js";

export class CongressManager extends BaseManager {
  _ServiceClass = CongressService;

  dataProps = {
    id: "number",
    points: "number",
    first_name: "string",
    last_name: "string",
    common_name: "string",
    suffix: "string",
    official_full: "string",
    picture: "string",
    party: "string",
    state: "string",
    chamber: "string",
    district: "number",
    website: "string",
    social: "object",
    congress: "number",
    status: "string",
    bioguide: "string",
    govtrack: "number",
    fec: "object",
    open_secrets: "string",
    icpsr: "number",
    cspan: "number",
    wikipedia: "string",
    birthday: "string",
    gender: "string",
    years_in_congress: "number",
    state_rank: "string",
    running_average: "number",
    trending: "number",
    created: "string",
    updated: "string"
  };

  get(id) {
    const path = `/api/members/${id}/`;
    return this._get(path);
  }
}

export class CongressListManager extends BaseListManager {
  _InstanceClass = CongressManager;
  _ServiceClass = CongressService;

  get(limit, offset, filters) {
    let path = `/api/members/?limit=${limit}&offset=${offset}`;
    for (const filter in filters) {
      path = `${path}&${filter}=${filters[filter]}`;
    }
    return this._get(path);
  }
}
